import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS]: {
		url: '/company/:companyId/trips/report/',
	},
  [ModulesConfigMap[ModulesMap.TRIPS].GET_TRIP]: {
		url: '/company/:companyId/trips/report/:machineId',
	},
  [ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_POPUP]: {
		url: '/company/:companyId/trips/report/:machineId/popup/',
	},
	[ModulesConfigMap[ModulesMap.TRIPS].GET_TRIPS_PREVIEW]: {
		url: '/company/:companyId/trips/report/:machineId/preview/',
	},
}
